import React from "react";
import TableRowsOutlinedIcon from "@mui/icons-material/TableRowsOutlined";
import Tooltip from "@material-ui/core/Tooltip";

const PathwayIcon = () => {
  return (
    <Tooltip title="'Pathway' Interaction">
      <TableRowsOutlinedIcon
        color="primary"
        sx={{
          color: "#d9d9d9",
          fontSize: "30pt",
          // float: "left",
          // marginTop: "20px",
          marginBottom: "-60px",
          marginLeft: "20px",
        }}
      />
    </Tooltip>
  );
};

export default PathwayIcon;
